import { FunctionalComponent } from 'preact'
// eslint-disable-next-line import/no-internal-modules
import Table from '@insided/deprecated-preact-components/table/Table'
// eslint-disable-next-line import/no-internal-modules
import { Model, TableRow } from '@insided/deprecated-preact-components/table/types'
// eslint-disable-next-line import/no-internal-modules
import Icon from '@insided/deprecated-preact-components/assets'
import CopyToClipboard from '@insided/shared/uikit/CopyToClipboard'
import globals from '@insided/deprecated-utils/globals'
import Button from '@insided/control/uikit/Button'

export interface CustomPage {
  widgets: Array<{}>
  seo_fields: {
    name: string
    description: string
  }
  slug: string
  title: string
  id: string
  community_id: string
}

interface CustomPagesListProps {
  customPages: CustomPage[]
  onCustomPageDelete: Function
}

interface CustomPagesListActionsProps {
  customPageId: string
  onCustomPageDelete: (event: MouseEvent) => void
}

interface CustomPagesListPageUrlProps {
  pageUrl: string
}

interface CustomPagesListPageNameProps {
  pageName: string
  pageUrl: string
}

const CustomPagesOverviewListPageName: FunctionalComponent<CustomPagesListPageNameProps> = ({ pageName, pageUrl }) => {
  return (
    <p className='custom-pages-list__centered-cell'>
      {pageName}
      <a href={pageUrl} target='_blank' rel='noreferrer' className='custom-pages-list__external-link'>
        <Icon icon='externalLink' width={16} height={16} color='#2b3346' />
      </a>
    </p>
  )
}

const CustomPagesOverviewListPageUrl: FunctionalComponent<CustomPagesListPageUrlProps> = ({ pageUrl }) => (
  <p className='custom-pages-list__centered-cell'>
    <a href={pageUrl} rel='noreferrer' target='_blank'>
      {pageUrl}
    </a>
    <CopyToClipboard text={pageUrl} />
  </p>
)

const CustomPagesOverviewListActions: FunctionalComponent<CustomPagesListActionsProps> = ({
  customPageId,
  onCustomPageDelete
}) => {
  return (
    <div>
      <a href={`/platform/custom-pages/${customPageId}/edit`}>
        <Button className='qa-edit-product-area' variant='secondary' title='Edit' />
      </a>
      <Button className='qa-edit-product-area' variant='warning' title='Delete' onClick={onCustomPageDelete} />
    </div>
  )
}

const generateCustomPagesListRows = (customPages: CustomPage[], onCustomPageDelete: Function): TableRow[] =>
  customPages.map((customPageData) => {
    const communityUrl = globals('communityUrl')
    return {
      pageName: customPageData.title,
      pageUrl: communityUrl.concat('/p/', customPageData.slug),
      pageData: customPageData,
      onCustomPageDelete
    }
  })

const customPagesListModel: Model[] = [
  {
    header: 'Page Name',
    accessor: 'pageName',
    cell: ({ pageName, pageUrl }) => <CustomPagesOverviewListPageName pageName={pageName} pageUrl={pageUrl} />
  },
  {
    header: 'URL',
    accessor: 'pageUrl',
    cell: ({ pageUrl }) => <CustomPagesOverviewListPageUrl pageUrl={pageUrl} />
  },
  {
    accessor: 'pageData',
    isHidden: true
  },
  {
    header: 'Actions',
    accessor: 'actions',
    cell: ({ onCustomPageDelete, pageData }) => (
      <CustomPagesOverviewListActions
        customPageId={pageData.id}
        onCustomPageDelete={() => onCustomPageDelete(pageData)}
      />
    )
  }
]

const CustomPagesList: FunctionalComponent<CustomPagesListProps> = ({ customPages, onCustomPageDelete }) => (
  <Table model={customPagesListModel} rows={generateCustomPagesListRows(customPages, onCustomPageDelete)} />
)

export default CustomPagesList
